import React, { Component } from 'react';
import Radium from 'radium';

const bounce = Radium.keyframes({
	"0%": {scale3d: "(0.1,0.1,0.1)", opacity: 0},
	"100%": {scale3d: "(1,1,1)", opacity: 1},
}, 'fadeIn');

class Modal extends Component {

	onStopPropagation(evt) {
		evt.stopPropagation();
	}

	render() {
		return (
			<div style={this.localStyles().container} onClick={this.props.onHide}>
				<div style={this.localStyles().modal} onClick={(evt) => this.onStopPropagation(evt)}>
					{this.props.children}
				</div>
			</div>
		);	
	}

	localStyles() {
		return {
			container: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: this.props.style.colors.transparentOverlay,
				zIndex: 9999
			},
			modal: {
				backgroundColor: this.props.style.colors.white,
				width: "60%",
				height: "60%",
				boxShadow: "rgba(0, 0, 0, 0.176) 0px 16px 48px 0px",
				padding: 40,
				borderRadius: 6,
				animation: 'all 0.5s ease-in-out',
				animationFillMode: "forwards",
				animationName: bounce
			}
		}
	}
}

export default Radium(Modal);


// WEBPACK FOOTER //
// ./src/components/Modal.js